<footer class="footer">
  <div class="footer-links">
    <a (click)="showAbout()">About</a>
    <span class="footer-dot"></span>
    <a (click)="showSupport()">Support</a>
    <span class="footer-dot"></span>
    <a (click)="showPrivacy()">Privacy Policy</a>
    <span class="footer-dot"></span>
    <a (click)="showTerms()">Terms of Service</a>
    <span class="footer-dot"></span>
    <a routerLink="/contact" routerLinkActive="active">Contact</a>
  </div>
  <span class="footer-spacer"></span>
  <span class="footer-copy">&copy; 2025 BookWise. All rights reserved.</span>
</footer>
